<template>
    <div>
        <div class="sw-survey-container">
            <div class="sw-width-full" v-if="!success">
                <form ref="form" class="sw-flex">
                    <component :component="form"
                               @submit="submit"
                               @updateContact="fillForm($event, 'contactData')"
                               @updateSurvey="fillForm($event, 'surveyData')"
                               :is="'form-slide'"
                               :contact-form="contactForm"
                               :survey-form="form">
                    </component>
                </form>
            </div>
            <template v-else>
                <div id="sw-anchor-2"></div>
                <div class="sw-mx-auto sw-thanks-message">
                    {{ form.thanks_message }}
                </div>
                <template v-if="!form.settings.silbitzUser">
                    <div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-md"
                         :class="show?'show':'hidden'">
                        <div class="relative p-4 w-full max-w-md max-h-full">
                            <div class="relative bg-white rounded-lg shadow">
                                <div class="p-4 md:p-5 text-center">
                                    <template v-if="emailInputExists">
                                        <div>
                                            <div class="flex justify-center items-center mb-5">
                                                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="70" viewBox="0 0 512 512" width="70" fill="#00AE8F"><path d="m298.789 313.693c-12.738 8.492-27.534 12.981-42.789 12.981-15.254 0-30.05-4.489-42.788-12.981l-209.803-139.873c-1.164-.776-2.298-1.585-3.409-2.417v229.197c0 26.278 21.325 47.133 47.133 47.133h417.733c26.278 0 47.133-21.325 47.133-47.133v-229.198c-1.113.834-2.249 1.645-3.416 2.422z"/><path d="m20.05 148.858 209.803 139.874c7.942 5.295 17.044 7.942 26.146 7.942 9.103 0 18.206-2.648 26.148-7.942l209.803-139.874c12.555-8.365 20.05-22.365 20.05-37.475 0-25.981-21.137-47.117-47.117-47.117h-417.766c-25.98.001-47.117 21.137-47.117 47.142 0 15.085 7.496 29.085 20.05 37.45z"/></svg>
                                            </div>
                                            <h3 class="mb-5 text-xl font-normal text-gray-800 font-semibold">
                                                Die Kostenindikation wird heruntergeladen und per E-Mail gesendet
                                            </h3>
                                            <p class="mb-5 text-base font-normal text-gray-500">
                                                Im Browser wird der Download gestartet und der Versand der E-Mail kann einige Minuten dauern, prüfe auch Deinen Spam Ordner.
                                            </p>
                                        </div>
                                        <button  @click="show = false" class="bg-sw text-center items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest focus:outline-none focus:shadow-outline-gray transition ease-in-out duration-150">Okay verstanden</button>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <div class="flex justify-center items-center mb-5">
                                                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="70" viewBox="0 0 512 512" width="70" fill="#00AE8F"><path d="m432 192h-125.25c-27.99 0-50.75-22.76-50.75-50.75v-125.25c0-5.76 1.52-11.24 4.27-16h-161.52c-19.16 0-34.75 15.59-34.75 34.75v442.5c0 19.16 15.59 34.75 34.75 34.75h314.5c19.16 0 34.75-15.59 34.75-34.75v-289.52c-4.76 2.75-10.24 4.27-16 4.27zm-235.31 100.69c6.25-6.25 16.37-6.25 22.62 0l20.69 20.68v-97.37c0-8.84 7.16-16 16-16s16 7.16 16 16v97.37l20.69-20.68c6.24-6.25 16.38-6.25 22.62 0 6.25 6.24 6.25 16.38 0 22.62l-48 48c-3.373 3.46-8.231 5.022-12.85 4.62-8.012-1.07-5.485-.335-57.77-52.62-6.25-6.24-6.25-16.38 0-22.62zm139.31 139.31h-160c-8.84 0-16-7.16-16-16s7.16-16 16-16h160c8.84 0 16 7.16 16 16s-7.16 16-16 16zm-29.25-272h125.25l-144-144v125.25c0 10.34 8.41 18.75 18.75 18.75z"/></svg>
                                            </div>
                                            <h3 class="mb-5 text-lg font-normal text-gray-800 font-semibold">
                                                Download wurde gestartet
                                            </h3>
                                            <p class="mb-5 text-base font-normal text-gray-500">
                                                Der Download wurde automatisch gestartet und kann über die heruntergeladenen Dateien geöffnet werden.
                                            </p>
                                        </div>
                                        <button @click="show = false" class="bg-sw text-center items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest focus:outline-none focus:shadow-outline-gray transition ease-in-out duration-150">Okay verstanden</button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import FormCheckbox from "@/Pages/Forms/Partials/Checkbox.vue";
import FormColumn from "@/Pages/Forms/Partials/Column.vue";
import FormInput from "@/Pages/Forms/Partials/Input.vue";
import FormDate from "@/Pages/Forms/Partials/Date.vue";
import Form from "@/Pages/Forms/Partials/Form.vue";
import FormTextarea from "@/Pages/Forms/Partials/Textarea.vue";
import FormSelect from "@/Pages/Forms/Partials/Select.vue";
import FormButton from "@/Pages/Forms/Partials/Button.vue";
import FormScalaQuestion from "@/Pages/Forms/Partials/ScalaQuestion.vue";
import FormSlide from "@/Pages/Forms/Partials/Slide.vue";
import axios from "axios";
import download from "downloadjs";
import Modal from "@/Jetstream/Modal";

export default {
    name: "PublicCostsIndicator",
    components: {
        Modal,
        FormCheckbox,
        FormColumn,
        FormInput,
        FormDate,
        Form,
        FormTextarea,
        FormSelect,
        FormButton,
        FormScalaQuestion,
        FormSlide
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        contactForm: {
            type: Object
        }
    },
    data() {
        return {
            contactData: {},
            surveyData: {},
            success: false,
            loading: false,
            show: false,
        }
    },
    computed: {
        emailInputExists() {
            let result = false;
            this.contactForm.form_components.forEach(row => {
                if ((row.attributes.label && (row.attributes.label).toLowerCase().includes('mail'))
                    || (row.attributes.placeholder && (row.attributes.placeholder).toLowerCase().includes('mail'))) {
                    result = true;
                }
            });
            return result;
        },
        origin() {
            if (typeof this.form.origin !== 'undefined') {
                return this.form.origin;
            }
            return 'https://tracker.schubwerk.de';
        }
    },
    methods: {
        fillForm(ev, dataVarName) {
            if (!Object.keys(this[dataVarName]).includes(ev.id)) {
                this.$set(this[dataVarName], ev.id, ev.value);
                this.$forceUpdate();
            } else {
                this[dataVarName][ev.id] = ev.value;
                this.$forceUpdate();
            }
        },
        async submit() {
            this.show = true;
            // this.$refs.thanksModal.showModal = true;
            // this.$refs.thanksModal.show();
            this.$forceUpdate();

            this.loading = true;
            await axios.post(this.origin+'/api/form/'+this.form.id+'/submit/costs-indicator', {
                surveyData: this.surveyData,
                trackContact: this.form.settings.track_contact,
                contactData: this.contactData
            }, {
                method : "POST",
                mode: 'cors',
                responseType: "blob",
                onSuccess: () => {
                    this.loading = false;
                    this.success = true;
                },
                onError: () => this.loading = false
            }).then((response) => {
                const content = response.headers["content-type"];

                if (content && content.includes("pdf")) {
                    let fileName = this.form.settings.silbitzUser ? 'Angebot_CITYSAFE' : 'WiCare – Kostenindikation';
                    let date = new Date();
                    fileName = `${fileName}_${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}.pdf`;
                    download(response.data, fileName, content);
                }

                this.success = true;
                this.loading = false;
                this.show = true;
                // this.$refs.thanksModal.showModal = true;
                // this.$refs.thanksModal.show();
                this.$forceUpdate();
            });
        }
    }
}
</script>

<style scoped>
.show {
    display: block;
}
.hidden {
    display: none;
}
.fixed {
    position: fixed;
}
.top-1\/2 {
    top: 50%;
}
.left-1\/2 {
    left: 50%;
}
.transform {
    transform: translate(-50%, -50%);
}
.z-50 {
    z-index: 50;
}
.w-full {
    width: 100%;
}
.max-w-md {
    max-width: 28rem;
}
.show {
    display: block;
}
.relative {
    position: relative;
}
.p-4 {
    padding: 1rem;
}
.text-center {
    text-align: center;
}
.bg-white {
    background-color: #fff;
}
.rounded-lg {
    border-radius: 0.75rem;
}
.shadow {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.mb-5 {
    margin-bottom: 1.25rem;
}
.text-xl {
    font-size: 1.25rem;
}
.font-normal {
    font-weight: 400;
}
.text-gray-800 {
    color: #2d3748;
}
.font-semibold {
    font-weight: 600;
}
.text-base {
    font-size: 1rem;
}
.text-gray-500 {
    color: #718096;
}
.flex {
    display: flex;
}
.justify-center {
    justify-content: center;
}
.items-center {
    align-items: center;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.border {
    border-width: 1px;
    border-style: solid;
}
.border-transparent {
    border-color: transparent;
}
.rounded-md {
    border-radius: 0.375rem;
}
.font-semibold {
    font-weight: 600;
}
.text-xs {
    font-size: 0.75rem;
}
.text-white {
    color: #fff;
}
.uppercase {
    text-transform: uppercase;
}
.tracking-widest {
    letter-spacing: 0.125em;
}
.focus\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.focus\:shadow-outline-gray:focus {
    box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.5);
}
.transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
}
.ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.duration-150 {
    transition-duration: 150ms;
}
h3, p{
    font-family: Poppins;
}
.bg-sw{
    background-color: #00AE8F;
}
</style>
